import styled from 'styled-components';

export const ToolTipIconWrapper = styled.div`
  cursor: pointer;
`;
